// extracted by mini-css-extract-plugin
export default {"offerCard":"OfferCard_offerCard__E+Pzm","offerCard__special":"OfferCard_offerCard__special__It5vO"};